// The readers of a JSON field the meta server may leave out, or a stored
// record may carry in the wrong type. Each one answers the zero of its
// type for anything else, so a parser states a shape and never throws.
// `api.ts` and `clanchat.ts` read a loose field through them, and the
// audio manifest, the music handoff, the settings and the look cache ask
// `isObject` before they read a field at all. The module imports nothing.

/** True for a plain object, the one shape a stored blob, a cached entry,
 *  a theme body or a manifest entry may take. */
export function isObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

/** A finite number, else 0. */
export function num(v: unknown): number {
  return typeof v === 'number' && Number.isFinite(v) ? v : 0;
}

/** A string, else ''. */
export function str(v: unknown): string {
  return typeof v === 'string' ? v : '';
}

/** The strings of a list, and nothing else; [] for a value that is no list. */
export function strList(v: unknown): string[] {
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}
